import React from 'react';
import './privacy.css';

function PrivacyAndPolicy() {
  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <h1>Privacy Policy</h1>
        <p>Last Updated: {new Date().toLocaleDateString()}</p>
      </header>

      <main className="privacy-content">
        <section className="privacy-section">
          <h2>Introduction</h2>
          <p>
            Community Eye Care Center is committed to protecting the privacy and security of our patients' 
            personal and health information. This Privacy Policy explains how we collect, use, disclose, 
            and safeguard your information when you visit our facility or use our services.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Information We Collect</h2>
          <p>We may collect the following types of information:</p>
          <ul>
            <li>Personal identification information (Name, date of birth, contact details)</li>
            <li>Health information (Medical history, eye examination results, treatment records)</li>
            <li>Insurance information</li>
            <li>Payment and billing information</li>
            <li>Technical data (when you use our website, such as IP address, browser type)</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>How We Use Your Information</h2>
          <p>Your information is used for the following purposes:</p>
          <ul>
            <li>To provide and manage your eye care treatment</li>
            <li>To process payments and insurance claims</li>
            <li>To communicate with you about appointments and follow-ups</li>
            <li>To improve our services and patient care</li>
            <li>To comply with legal and regulatory requirements</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Information Sharing and Disclosure</h2>
          <p>
            We do not sell or rent your personal information. We may share your information with:
          </p>
          <ul>
            <li>Healthcare providers involved in your treatment</li>
            <li>Your insurance company for claims processing</li>
            <li>Legal authorities when required by law</li>
            <li>Third-party service providers who assist in our operations (under confidentiality agreements)</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal 
            information against unauthorized access, alteration, disclosure, or destruction.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access and request copies of your health records</li>
            <li>Request corrections to inaccurate or incomplete information</li>
            <li>Request restrictions on certain uses and disclosures</li>
            <li>Receive an accounting of disclosures of your health information</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy periodically. We will notify you of significant changes 
            by posting the new policy on our website and updating the "Last Updated" date.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy or our privacy practices, please contact:
          </p>
          <address>
            Phone: 011 77 00 904<br />
            Email: communityeyecare@gmail.com
          </address>
        </section>
      </main>


    </div>
  );
}

export default PrivacyAndPolicy;